import { createContext } from 'react'
import type { NotificationRecord, UserNotificationPreferences } from '../types/schema'

export type NotificationQuickAction =
  | 'OPEN'
  | 'DISMISS'
  | 'ACCEPT_INVITE'
  | 'REVIEW_INVITE'
  | 'OPEN_CHAT'
  | 'OPEN_TIMELINE_ITEM'
  | 'OPEN_CHECKLIST_NODE'
  | 'JOIN_RAID'
  | 'TOP_UP_CREDITS'

export interface NotificationContextValue {
  notifications: NotificationRecord[]
  unreadCount: number
  preferences: UserNotificationPreferences | null
  openNotification: (notification: NotificationRecord, action?: NotificationQuickAction) => Promise<void>
  markRead: (notificationId: string) => Promise<void>
  markAllRead: () => Promise<void>
  clearNotification: (notificationId: string) => Promise<void>
  clearAll: () => Promise<void>
  restoreNotifications: (notificationIds: string[]) => Promise<void>
  removeDigestItem: (digestId: string, itemIndex: number) => Promise<void>
  savePreferences: (next: UserNotificationPreferences) => Promise<void>
}

export const NotificationContext = createContext<NotificationContextValue | undefined>(undefined)
